import React from 'react'
import { View } from 'react-native'
import { Divider } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { Subscription } from '@src/types.ts'
import { getSubscriptionTagDescriptor } from '@screens/Marketplace/utils/utils.ts'
import { PurchasedProductSummary } from '@screens/Marketplace/components/NewMarketplace/PurchasedProductSummary.tsx'
import { Text } from '@components/base'

interface SubscriptionsGroupProps {
  title: string
  showTitle?: boolean
  subscriptions: Subscription[]
}

export const SubscriptionsGroup = ({
  title,
  subscriptions,
  showTitle = true,
}: SubscriptionsGroupProps) => {
  const styles = useStyleSheet(themedStyle)

  return (
    <View>
      {showTitle && (
        <>
          <View style={styles.titleSection}>
            <Text type="regular" bold>
              {title}
            </Text>
          </View>

          <Divider style={styles.divider} />
        </>
      )}

      <View>
        {subscriptions.map((subscription) => {
          return (
            <PurchasedProductSummary
              key={`sub-${subscription.id}`}
              subscription={subscription}
              product={subscription.primaryProduct}
              {...getSubscriptionTagDescriptor(subscription)}
            />
          )
        })}
      </View>
    </View>
  )
}

const themedStyle = StyleService.create({
  titleSection: {
    marginVertical: 16,
  },
  divider: {
    backgroundColor: 'theme.surface.base2',
    height: 2,
  },
})
